import React, {useRef} from 'react';
import WithApplicationView, {WithApplicationViewProps} from '../../hocs/WithApplicationView';
import Reactivate from './Reactivate';
import {PreSignUp, ApplicationHeader, ApplicationForm} from '../../components';
import {canReactivate, canSignUp} from '../../utils/ValidationUtils';
import {RedirectWithParams} from 'epic-diesel-common';

export type ReactivateViewProps = WithApplicationViewProps;

const ReactivateView: React.FC<ReactivateViewProps> = props => {
    const reactivateRef = useRef();

    const {accountInfo} = props.userState || {};
    const {isLoggedIn} = accountInfo;
    const {affiliateAccount} = props.influencerState || {};

    const configState = props.configState;
    const {talonFlowID, enableTalon} = configState || {};
    const {enableReactivation, enableCodeSelfService} = configState || {};

    if (!isLoggedIn || !enableReactivation || !canReactivate(affiliateAccount)) {
        return <RedirectWithParams to="overview" ignoreSearch />;
    }

    const {reactivateInfluencerProfile, ...rest} = props;

    const _props = {
        ...rest,
        reactivateInfluencerProfile,
        ref: reactivateRef,
        children: Reactivate,
        enableTalon,
        flow: talonFlowID,
        createInfluencerProfile: reactivateInfluencerProfile,
        configState,
        disclaimerEnabled: enableCodeSelfService ? false : true
    };

    return (
        <>
            <ApplicationHeader
                userState={props.userState}
                code="epic.affiliate.common.tos.review.v2"
                redirectPath="overview"
            />
            {!canSignUp(accountInfo) ? (
                <PreSignUp
                    messages={props.messages}
                    userState={props.userState}
                    influencerState={props.influencerState}
                    resendEmailVerification={props.resendEmailVerification}
                    checkSignupRequirementsMet={props.checkSignupRequirementsMet}
                />
            ) : (
                <ApplicationForm {..._props} />
            )}
        </>
    );
};

export default WithApplicationView(ReactivateView);
